<template>
	<main>
		<div
			:class="{
				mobile: $store.getters.layout == 'Mobile',
			}"
		>
			<div
				v-show="$route.meta.showHeader"
				:class="{
					'mobile-top-container': $store.getters.layout == 'Mobile',
				}"
			>
				<top
					v-show="$route.meta.showHeader"
					:showTopNav="$route.meta.showTopNav"
				/>
			</div>
			<div
				v-show="$route.meta.showTopNav"
				:class="{
					'mobile-sports_list-container': $store.getters.layout == 'Mobile',
				}"
			>
				<div class="sports-list-wrapper">
					<sports-list v-show="$route.meta.showTopNav" />
				</div>
			</div>
			<div
				:class="{
					'mobile-router_view-container': $store.getters.layout == 'Mobile',
				}"
			>
				<keep-alive
					:include="[
						'home',
						'live',
						'Jengabet',
						'boosted-multibet',
						'casino',
						'casino-category',
						'my-bets',
					]"
				>
					<router-view />
				</keep-alive>
			</div>
			<div
				v-show="$route.meta.showFooter"
				:class="{
					'mobile-bottom-container': $store.getters.layout == 'Mobile',
				}"
			>
				<mini-betslip v-if="showMiniBetslip" />
				<bottom v-show="$route.meta.showFooter" />
				<support-contacts v-if="env.supportContactsTab.enabled && contactsTabSupportsLayout" />
				<zendesk-chat v-if="env.zendeskChat.enabled"/>
				<acca-on-mini-betslip
					v-if="
						env.availableFeatures.accaBonus &&
						['home', 'prebets-markets', 'live', 'live-markets'].includes(
							$route.name
						)
					"
				/>
				<data-notifier />
			</div>
			<scratch-to-win-promo
				v-if="
					env.availableFeatures.scratchToWinPromo &&
						$route.name == 'home' &&
						!checkDayIfWeekend &&
						!isIOS()
				"
			></scratch-to-win-promo>

			<!-- Roadblock Banner -->
			<road-block-banner
				v-if="roadBlockBanner && env.availableFeatures.roadBlockBanner &&
					$route.name == 'home'"
				:imageUrl="roadBlockBanner.imageUrl"
				:showCTAs="roadBlockBanner.showCta"
				:routerBtn="{
					title: $t(roadBlockBanner.routerBtn.title),
					path: roadBlockBanner.routerBtn.path,
				}"
				:btnStyle="'block'"
				:roadblockLink="roadBlockBanner.route"
			></road-block-banner>
		</div>
	</main>
</template>

<script>
import Top from "../components/Shared/Top.vue";
import Bottom from "../components/Shared/Bottom.vue";
import MiniBetslip from "../components/Shared/MiniBetslip.vue";
import AccaOnMiniBetslip from "../components/Shared/AccaOnMiniBetslip.vue";
import DataNotifier from "../components/Shared/DataNotifier/index.vue";
import SportsList from "../components/Prebets/SportsList.vue";
import SupportContacts from "../components/Shared/SupportContacts.vue";
import ScratchToWinPromo from "../components/Offers/Promos/DownloadApp/CTA.vue";
import RoadBlockBanner from "../components/Shared/RoadBlockBanner.vue";
import _ from "lodash";
import ZendeskChat from "../components/Shared/ZendeskChat.vue";
export default {
	name: "mobile-layout",
	components: {
		ZendeskChat,
		Top,
		Bottom,
		MiniBetslip,
		AccaOnMiniBetslip,
		DataNotifier,
		SportsList,
		SupportContacts,
		ScratchToWinPromo,
		RoadBlockBanner,
	},
	data() {
		return {
			windowWidth: window.innerWidth,
			displaySelectedItem: false,
			checkDayIfWeekend: false,
		};
	},
	created() {
		let vm = this;
		vm.setSelectedSport();
	},
	beforeMount() {
		// Emit event that will refresh the sportslist every 30 minutes. Event is called in App.vue
		setInterval(() => {
			this.$root.$emit("refresh-sports-list");
		}, 1800000);
	},
	mounted() {

		this.waitForZendesk(() => {
			zE('messenger', 'hide')

			zE("messenger:on", "close", function () {
				zE('messenger', 'hide')
			})
		})

		this.checkIfWeekend();
		this.$nextTick(() => {
			window.addEventListener("resize", this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.onResize);
	},
	computed: {
		contactsTabSupportsLayout(){
			console.log("contactsTabSupportsLayout ",this.env.supportContactsTab.layouts.includes(this.$store.getters.layout));
			return this.env.supportContactsTab.layouts.includes(this.$store.getters.layout)
		},
		showMiniBetslip() {
			return this.$route.meta.miniBetslipViewable == true;
		},
		selectedCompetition() {
			return this.$store.getters.selectedCompetition;
		},
		selectedSport() {
			return this.$store.getters.selectedSport;
		},
		roadBlockBanner(){
			let roadBlockBanners = this.env.roadBlockBannerConfigs;
			return roadBlockBanners.find((banner)=>{
				return this.isContentActive(banner) && this.isValidContent(banner) && this.showToday(banner.days);
			})
		},
	},
	watch: {
		$route: {
			handler: function() {
				let vm = this;
				vm.setSelectedSport();
			},
		},
	},
	methods: {
		isIOS() {
			if (typeof window === `undefined` || typeof navigator === `undefined`)
				return false;

			return /iPhone|iPad|iPod/i.test(
				navigator.userAgent ||
					navigator.vendor ||
					(window.opera && opera.toString() === `[object Opera]`)
			);
		},
		showToday(days) {
			let vm = this;

			let date = new Date();
			let day = date.getDay();
			let selectedDays = days;

			return selectedDays.length !== 0 ? selectedDays.includes(day) : false;
		},
		checkIfWeekend() {
			let vm = this;
			let date = new Date();
			let day = date.getDay();
			let checkDay = day === 6 || day === 0;
			vm.checkDayIfWeekend = checkDay ? true : false;
		},
		setSelectedSport() {
			let vm = this;
			let newSport = null;
			let newCompetition = null;
			const routeName = vm.$route.name;
			const sportRouteNames = ["sport", "sport-countries", "sport-competition"];
			const liveRouteNames = ["live", "lite-sport", "live-markets"];

			if (sportRouteNames.includes(routeName)) {
				// get selected sport from navigation arrays - mainSports / otherSports based on the sport_name field in the object using the route param sportName
				newSport = vm.getSportFromUrl();
				newCompetition = vm.getCompetitionFromUrl();
			} else {
				// get selected sport / menu item from navigation arrays - mainSports / otherSports based on the selected field in the object
				newSport = vm.getSportFromNavArrays(routeName);
			}

			// Set default selected item
			if (newSport == undefined) {
				// Set Default Selected Item
				if (vm.$store.getters.selectedSport !== null) {
					newSport = vm.$store.getters.selectedSport;
				} else {
					const defaultSport = this.env.defaultSport;
					newSport = vm.getSportById(defaultSport.sport_id);
				}
			}

			// set selected sport for home page
			if (routeName == "home") {
				const defaultSport = this.env.defaultSport;
				newSport = vm.getSportById(defaultSport.sport_id);
			}

			if (liveRouteNames.includes(routeName)) {
				// vm.$store.commit("UPDATE_SELECTED_SPORT", null);
			} else if (
				vm.selectedSport == null ||
				vm.selectedSport.sport_id != newSport.sport_id
			) {
				vm.$store.commit("UPDATE_SELECTED_SPORT", newSport);

				if (sportRouteNames.includes(routeName)) {
					vm.$store.dispatch("getCountries").then((countries) => {
						vm.$store.commit("SET_COUNTRIES", countries);
					});
				}
			}

			// Set competition
			if (
				sportRouteNames.includes(routeName) &&
				vm.selectedCompetition.competition_id != newCompetition.competition_id
			) {
				vm.$store.commit(
					"UPDATE_SELECTED_COMPETITION",
					vm.getCompetitionFromUrl()
				);
			}

			// Set selectedSport Item's selectedVisible property base on the
			if (vm.$store.getters["navigation/unionSports"].length > 0) {
				vm.updateSelectedSportForScreenSize();
			} else {
				newSport.selectedVisible = true;
				vm.$store.commit("UPDATE_SELECTED_SPORT", newSport);
			}

			// Emit event to scroll to menu item based on the selected sport value
			this.$root.$emit("scroll-to-sport");
		},
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		getCompetitionFromUrl() {
			let competitionName = this.$route.params.competitionName;
			if (!competitionName)
				return {
					competition_id: null,
					competition_name: null,
				};
			let selectedCountry = this.$store.getters.countries.data.find(
				(country) => {
					return country.competitions.find((competition) => {
						return competition.urlSlug === competitionName;
					});
				}
			);
			let selectedCompetition = selectedCountry.competitions.find(
				(competition) => {
					return competition.urlSlug === competitionName;
				}
			);
			return selectedCompetition;
		},
		getSportFromUrl() {
			let vm = this;
			let sportName = this.$route.params.sportName;

			let selectedSport = undefined;
			// Get item from mainSports / otherSports arrays based on whether the sportName parameter value matches the formated sport_name of the objects in the arrays
			if (
				vm.$store.getters["navigation/mainSports"].length > 0 &&
				_.find(vm.$store.getters["navigation/mainSports"], (sport) => {
					return (
						sport.sport_name
							.split(" ")
							.join("-")
							.toLowerCase() == sportName
					);
				}) != undefined
			) {
				selectedSport = _.find(
					vm.$store.getters["navigation/mainSports"],
					(sport) => {
						return (
							sport.sport_name
								.split(" ")
								.join("-")
								.toLowerCase() == sportName
						);
					}
				);
			} else if (
				vm.$store.getters["navigation/otherSports"].length > 0 &&
				_.find(vm.$store.getters["navigation/otherSports"], (sport) => {
					return (
						sport.sport_name
							.split(" ")
							.join("-")
							.toLowerCase() == sportName
					);
				}) != undefined
			) {
				selectedSport = _.find(
					vm.$store.getters["navigation/otherSports"],
					(sport) => {
						return (
							sport.sport_name
								.split(" ")
								.join("-")
								.toLowerCase() == sportName
						);
					}
				);
			} else if (
				vm.$store.getters["navigation/thirdRow"].length > 0 &&
				_.find(vm.$store.getters["navigation/thirdRow"], (sport) => {
					return (
						sport.sport_name
							.split(" ")
							.join("-")
							.toLowerCase() == sportName
					);
				}) != undefined
			) {
				selectedSport = _.find(
					vm.$store.getters["navigation/thirdRow"],
					(sport) => {
						return (
							sport.sport_name
								.split(" ")
								.join("-")
								.toLowerCase() == sportName
						);
					}
				);
			}
			return selectedSport;
		},
		getSportFromNavArrays(routeName) {
			// Get item from mainSports / otherSports arrays based on whether the routeName value exists in the selected field in the objects in the arrays
			// Returns undefined if no match
			let vm = this;
			if (
				vm.$store.getters["navigation/mainSports"].length > 0 &&
				_.find(vm.$store.getters["navigation/mainSports"], (sport) => {
					return _.includes(sport.selected, routeName);
				}) != undefined
			) {
				return _.find(vm.$store.getters["navigation/mainSports"], (sport) => {
					return _.includes(sport.selected, routeName);
				});
			} else if (
				vm.$store.getters["navigation/otherSports"].length > 0 &&
				_.find(vm.$store.getters["navigation/otherSports"], (sport) => {
					return _.includes(sport.selected, routeName);
				}) != undefined
			) {
				return _.find(vm.$store.getters["navigation/otherSports"], (sport) => {
					return _.includes(sport.selected, routeName);
				});
			} else if (
				vm.$store.getters["navigation/thirdRow"].length > 0 &&
				_.find(vm.$store.getters["navigation/thirdRow"], (sport) => {
					return _.includes(sport.selected, routeName);
				}) != undefined
			) {
				return _.find(vm.$store.getters["navigation/thirdRow"], (sport) => {
					return _.includes(sport.selected, routeName);
				});
			}
		},
		getSportById(sportId) {
			// Get item from mainSports / otherSports arrays based on whether the sportId value matches the sport_id in the objects in the arrays
			let vm = this;
			if (
				vm.$store.getters["navigation/mainSports"].length > 0 &&
				_.find(vm.$store.getters["navigation/mainSports"], (sport) => {
					return sport.sport_id == sportId;
				}) != undefined
			) {
				return _.find(vm.$store.getters["navigation/mainSports"], (sport) => {
					return sport.sport_id == sportId;
				});
			} else if (
				vm.$store.getters["navigation/otherSports"].length > 0 &&
				_.find(vm.$store.getters["navigation/otherSports"], (sport) => {
					return sport.sport_id == sportId;
				}) != undefined
			) {
				return _.find(vm.$store.getters["navigation/otherSports"], (sport) => {
					return sport.sport_id == sportId;
				});
			}
		},
		getIndexInMainSports(selectedSport) {
			let vm = this;
			// Get index of item from mainSports that are currently visible
			if (vm.$store.getters["navigation/mainSports"].length == 0) {
				return -1;
			}
			const index = _.findIndex(
				_.filter(vm.$store.getters["navigation/mainSports"], (spt) => {
					return spt.visible == true;
				}),
				(sport) => {
					return sport.sport_name == vm.selectedSport.sport_name;
				}
			);
			return index;
		},
		getIndexInUnionSports(selectedSport) {
			let vm = this;
			// Get index of item from mainSports that are currently visible
			if (vm.$store.getters["navigation/unionSports"].length == 0) {
				return -1;
			}
			const index = _.findIndex(
				_.filter(vm.$store.getters["navigation/unionSports"], (spt) => {
					return spt.visible == true;
				}),
				(sport) => {
					return sport.sport_name == vm.selectedSport.sport_name;
				}
			);
			return index;
		},
		updateSelectedSportForScreenSize() {
			let vm = this;
			const selectedSportIndex = vm.getIndexInUnionSports(vm.selectedSport);
			let modNewSport = vm.$store.getters.selectedSport;
			const windowWidth = vm.windowWidth;
			// set items visible on the first row of mainSports
			let maxItemIndex = 4;
			if (windowWidth < 667) {
				maxItemIndex = 4;
			} else if (windowWidth >= 667) {
				maxItemIndex = 7;
			}

			if (selectedSportIndex >= 0 && selectedSportIndex <= maxItemIndex) {
				modNewSport.selectedVisible = false;
			} else {
				modNewSport.selectedVisible = true;
			}

			vm.$store.commit("UPDATE_SELECTED_SPORT", modNewSport);
		},
	},
};
</script>

<style lang="scss">
.mobile {
	position: relative;
	top: 0;
	left: 0;
	min-height: 100vh;
	width: 100%;
	display: block;
	background-color: var(--white);
	&-top {
		&-container {
			width: 100%;
			height: var(--mobile-top-container-height);
			margin: 0px;
			position: fixed;
			top: 0;
			left: 0;
			z-index: 999998;
		}
	}
	&-sports_list {
		&-container {
			width: 100%;
			height: var(--mobile-sports-list-container-height);
			margin: 0px;
			margin-top: var(--margin-top-without-nav);
			padding: 0px;
			z-index: 999998;
		}
	}
	&-router_view {
		&-container {
			width: 100%;
			min-height: var(--mobile-routerview-container-height);
			margin: 0px;
			margin-bottom: calc(var(--margin-bottom));
			padding: 0px;
			padding-top: var(--padding-top-tiny);
			padding-bottom: calc(var(--padding-bottom-mobile));
			transition: all 0.4s ease;
		}
	}
	&-bottom {
		&-container {
			background-color: var(--white);
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			height: var(--mobile-bottom-container-height);
			margin: 0px;
			padding: 0px;
			z-index: 999998;
		}
	}
}
.sports-list-wrapper {
	position: fixed;
	min-height: 59px;
	transition: all 0.5s ease-in-out;
	z-index: 999998;
	outline: none;
}
</style>
